export default __webpack_public_path__ + "static/media/token_eco.4307c4fc.png";